@switch (version()) {
  @case ('classic') {
    <ai-hub-classic
      #hubView
      class="flex-1 min-h-0"
      (actionCompleted)="actionCompleted.emit($event)"
    />
  }
  @case ('v2') {
    <ai-hub-v2
      #hubView
      class="flex-1 min-h-0"
      (actionCompleted)="actionCompleted.emit($event)"
    />
  }
}
